export enum Stage {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
}

export interface ApplicationConfig {
  apiUrl: string;
  csAgentApiUrl: string;
  internalApiUrl: string;
  googleOAuthClientId: string;
  apiKey: string;
  stage: Stage;
  sheetId: string;
  wpAdminUrl: string;
  adminUrl: string;
  n8nWebhookBaseUrl: string;
  /** Slack workspace the agents live in; scopes the deep link when a user is in several. */
  slackTeamId: string;
  logtoEndpoint: string;
  /** Empty until this stage has a Logto application; staff sign-in stays hidden while it is. */
  logtoAppId: string;
  /** Membership of this organization is what makes a signed-in account staff. */
  logtoStaffOrganizationId: string;
}
